module.exports = __webpack_public_path__ + "img/icon-chevron-right.d8486252.svg";